import api from "./api";

export const getDetailBookingWaitingPayment = async (id) => {
  return api
    .get({
      endpoint: `/booking/own/waiting-payment/${id}`,
      port: process.env.REACT_APP_PORT_BOOK,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
